import React, { useEffect, useState, useRef } from 'react';
import './LiveShow.scss';
import { IComponentLiveShow } from '../../component';
import useTheme from '../hooks/useTheme';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import { IMedium } from '../../store/VideoStore';
import RootStore from '../../store/RootStore';
import { style } from '../../utils/image';
import ReactSVG from 'react-svg';
import intl from 'react-intl-universal';

interface ILiveShow extends IComponentLiveShow {
  rootStore?: RootStore;
  onPlayVideo: (item: IMedium, index: number) => void;
  inSearch?: string;
  currentIndex: number;
}

const Index = (props: ILiveShow) => {
  const { inSearch, rootStore, mode, onPlayVideo, currentIndex } = props;
  const { videoStore } = rootStore!;
  const { h1Color, h2Color, mainColor } = useTheme();

  let list = videoStore.liveshow_list.items;
  let total = videoStore.liveshow_list.total;

  const renderHItem = (it: IMedium, index: number) => {
    return (
      <div
        key={it.id}
        id={`liveshow_${index}`}
        className="liveshow-item type-h"
        onClick={() => {
          onPlayVideo && onPlayVideo(it, index);
        }}
      >
        <div className="wrapper">
          <div className="thumb">
            <img src={style(it.thumb, 'wx_375_240')} />
          </div>
          <div className="ico-play">
            <ReactSVG src={require('../../svg/video-play.svg')} />
          </div>
          <div className="title">{it.desc}</div>
        </div>
      </div>
    );
  };

  const renderVItem = (it: IMedium, index: number) => {
    return (
      <div
        key={it.id}
        id={`liveshow_${index}`}
        className="liveshow-item type-v"
        onClick={() => {
          onPlayVideo && onPlayVideo(it, index);
        }}
      >
        <div className="wrapper">
          <div className="thumb">
            <img src={style(it.thumb, 'wx_375_240')} />
          </div>
          <div className="icon-play">
            <ReactSVG src={require('../../svg/video-play.svg')} />
          </div>
          <div className="title">{it.desc}</div>
        </div>
      </div>
    );
  };

  const renderItem = (it: IMedium, index: number) => {
    if (currentIndex >= 0) {
      return (
        <div className="liveshow-item" key={it.id}>
          <div className="wrapper">
            <div style={{ paddingBottom: mode == 'h' ? '56%' : '177%' }} />
          </div>
        </div>
      );
    }
    if (mode == 'h') {
      return renderHItem(it, index);
    }
    if (mode == 'v') {
      return renderVItem(it, index);
    }
  };

  const renderEmpty = () => {
    if (total > -1) {
      if (!!props.inSearch) {
        return (
          <div className="empty">
            <img src={require('../../assets/no-video.png')} />
            <p style={{ color: h2Color }}>{intl.get('Not found any video')}</p>
          </div>
        );
      } else {
        return (
          <div className="empty">
            <img src={require('../../assets/no-video.png')} />
            <p style={{ color: h2Color }}>{intl.get('No hot video')}</p>
          </div>
        );
      }
    }

    return null;
  };

  return (
    <div className="liveshow">
      {!!inSearch && videoStore.liveshow_search.total == 0
        ? renderEmpty()
        : list && list.length
        ? list.map(renderItem)
        : renderEmpty()}
    </div>
  );
};

export default inject('rootStore')(observer(Index));
